import { FaMugHot, FaHeart, FaUser } from "react-icons/fa";

const whyChooseUs = {
    sub: "Why Choose Us",
    heading: "Experience the Best Coffee Shop in Town",
    content: "At Brewtopia, we are committed to serving the finest coffee. Enjoy a exceptional customer service with every visit.",
    points: [
        {
            id: 1,
            icon: <FaMugHot />,
            title: "Freshly Brewed Daily",
            content: "We source the highest-quality beans, freshly ground and brewed daily for a rich and flavorful cup every time.",
        },
        {
            id: 2,
            icon: <FaHeart />,
            title: "Passion for Coffee",
            content: "Our team is passionate about coffee, ensuring each drink is crafted to perfection, whether it's an espresso or a latte.",
        },
        {
            id: 3,
            icon: <FaUser />,
            title: "Cozy and Inviting Atmosphere",
            content: "Our coffee shop provides a warm environment for friends, colleagues, and solo coffee lovers alike.",
        },
    ]
};

export default whyChooseUs;